import {
    Button,
    Typography,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import VerificationInput from "react-verification-input";
import { Dispatch, SetStateAction, useEffect, useState } from "react";
import HeaderForgotPassword from "./HeaderForgotPassword";

interface CodeResetProps {
    email: string;
    code: string;
    setCode: Dispatch<SetStateAction<string>>;
    onEmailSubmit: () => void;
    setIsValidCodeForm: Dispatch<SetStateAction<boolean>>;
}

const LENGTH_CODE = 6;
const SECONDE = 60;
const MILLISECONDS = 1000;
const MINUTE = 10
const RESET_CODE_STORAGE = "resetCodeTimestamp";
export const EMAIL_STORAGE = "email";
const CodeReset = ({
    email,
    code,
    setCode,
    onEmailSubmit,
    setIsValidCodeForm
}: CodeResetProps) => {
    const { t } = useTranslation();
    const [isResendAvailable, setIsResendAvailable] = useState(true);
    const [timer, setTimer] = useState<number | undefined>();
    const getStorage = (key: string) => localStorage.getItem(key);
    const setStorage = (key: string, value: string) => localStorage.setItem(key, value);
    const dateNow = new Date().getTime();

    const onResendCode = () => {
        setIsResendAvailable(false);
        setStorage(RESET_CODE_STORAGE, dateNow.toString());
        setStorage(EMAIL_STORAGE, email);
        setTimer(SECONDE * MINUTE);
        onEmailSubmit();
    };

    useEffect(() => {
        setIsValidCodeForm(code !== "" && code.length === LENGTH_CODE)
    }, [code])


    useEffect(() => {
        const savedTimer = getStorage(RESET_CODE_STORAGE);
        const savedEmail = getStorage(EMAIL_STORAGE);

        if (savedEmail !== email) return;

        const elapsedTime = savedTimer ? Math.floor((dateNow - parseInt(savedTimer)) / MILLISECONDS) : undefined;
        const remainingTime = elapsedTime !== undefined ? MINUTE * SECONDE - elapsedTime : undefined;

        setIsResendAvailable(remainingTime === undefined || remainingTime <= 0);
        setTimer(remainingTime);
    }, []);

    useEffect(() => {
        let countdown: NodeJS.Timeout;

        if (isResendAvailable && timer === undefined) return;

        countdown = setInterval(() => {
            setTimer(prevTimer => {
                if (prevTimer && prevTimer <= 0) {
                    clearInterval(countdown);
                    setIsResendAvailable(true);
                } else {
                    return (prevTimer || 0) - 1;
                }
            });
        }, MILLISECONDS);


        return () => {
            clearInterval(countdown);
        };
    }, [isResendAvailable, timer]);

    const displayTimerText = () => {
        if (!timer || timer <= 0) return " ";

        const minutes = Math.floor(timer / SECONDE);
        const seconds = timer % SECONDE;
        return `${t("passwordReset.counterResendCode_1")}  ${minutes} ${t("passwordReset.minutes")} ${seconds} ${t("passwordReset.seconds")} ${t("passwordReset.counterResendCode_2")}`;
    };


    return (
        <HeaderForgotPassword title={t("passwordReset.title")}>
            <VerificationInput placeholder="" validChars="0-9" value={code} onChange={setCode} inputProps={{ inputMode: "numeric" }} />

            <Typography align="center" sx={{ mt: 5, fontSize: 13 }}>
                {t("passwordReset.enterCodeMessage")} {email}
            </Typography>

            {!isResendAvailable &&
                <Typography align="center" sx={{ fontSize: 13, marginTop: 3 }}>
                    {displayTimerText()}
                </Typography>}
            <Button
                sx={{ textAlign: "center", alignContent: "center", alignItems: "center", justifyContent: "center", justifyItems: "center" }}
                onClick={onResendCode}
                disabled={!isResendAvailable}
            >
                {t("login.resendCode")}
            </Button>
        </HeaderForgotPassword>
    );
};

export default CodeReset;
